<template>
  <div>
    <nav class="nav navbar fixed-top bg-white">
      <div class="nav-item">
        <button class="btn btn-outline" @click.prevent="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </button>
      </div>
      <router-link :to="`/community/${contactId}`" class="navbar-brand float-end text-decoration-none d-flex align-items-center gap-2">
        <img v-if="contact.profile_image" :src="contact.profile_image" class="c-nav-avatar" />
        <b>{{ fullName }}</b>
      </router-link>
    </nav>
    <div class="container-fluid mt-2 py-5">
      <channel-private :channelId="channelId" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChannelPrivate from '@/components/channel/channel-private.vue'

export default {
  name: 'ContactListView',
  components: {
    ChannelPrivate
  },
  props: {
      channelId: {type: String, required: true},
      contactId: {type: String, required: true},
  },

  data() {
    return {
      contact: {},
    }
  },

  computed: {
    fullName() {
      return `${this.contact.first_name || ''} ${this.contact.last_name || ''}`.trim() || this.contact.username
    },
  },

  created() {
    this.fetchContact()
  },

  methods: {
    fetchContact() {
      let me = this
      let params = {uuid: [this.contactId]}
      this.$api.get('/community-users/', {params: params}).then(function(response){
        if (response.data.results.length)
          me.contact = response.data.results[0]
      })
    }
  }
}
</script>

<style scoped>
.c-nav-avatar {
  height: 28px;
  width: 28px;
  object-fit: cover;
  border-radius: 50%;
}
</style>
